<template>
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9L12 15L18 9" class="stroke-current" stroke-width="2" stroke-linecap="square" />
  </svg>
</template>
